import request from "../utils/request";

// website/user/getCodCalendar https://api.mysave.co/express_pre/agent/getCodCalendar?date=2024-07-09
export function getCodCalendar(data) {
  return request({
    url: '/agent/getCodCalendar',
    method: 'get',
    params: data
  })
}


// agent/queryCodInfo
export function queryCodInfo(data) {
  return request({
    url: '/agent/queryCodInfo',
    method: 'post',
    data: data
  })
}


// user/cert/certAgentCodInfoAndType
export function certAgentCodInfoAndType(data) {
  return request({
    url: '/cert/certAgentCodInfoAndType',
    method: 'post',
    data: data
  })
}